import React, { useEffect, useState } from "react";
import Card from "../../../elements/Card";
import PaidTicket from "../../../elements/tabContent/PaidTicket";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { ticketDetails } from "../../../../services/ticketService";
import { useQuery } from "@tanstack/react-query";
import { t } from "i18next";
import LangSwitch from "../../../elements/LangSwitch";

const CreateTickets = ({ eventDetails = {} }) => {
  const [selectedTime, setSelectedTime] = useState("paid");
  const { ticketId } = useParams();
  const { lang } = useSelector((state) => state?.langProvider);
  const [selectedLang, setSelectedLang] = useState(lang || "en");

  const timeOptions = [
    { label: t("Paid"), value: "paid" },
    { label: t("Free"), value: "free" },
    { label: t("Donation"), value: "donation" },
  ];

  const {
    data: ticketDetailsData,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: ["ticket-details", ticketId],
    queryFn: async () => {
      const res = await ticketDetails({ id: ticketId, type: "front" });
      return res;
    },
    enabled: !!ticketId,
    staleTime: 300000,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (ticketId && ticketDetailsData?.data?.paymentType) {
      setSelectedTime(ticketDetailsData.data.paymentType);
    }
  }, [ticketDetailsData?.data?.paymentType, ticketId]);

  const getComponentByType = (type) => {
    return (
      <PaidTicket
        eventDetails={eventDetails}
        paymentType={type}
        ticketDetailsData={ticketDetailsData?.data || {}}
        selectedLang={selectedLang}
        currencySymbol={eventDetails?.currency?.symbol || "$"}
      />
    );
  };

  return (
    <div className="space-y-7">
      <div className="bg-white py-4 px-4 rounded-md">
        <div className="space-y-6">
          <Card
            title={t(
              `${
                !ticketId
                  ? "Create"
                  : ticketDetailsData?.data?._id
                  ? "Update"
                  : "Create"
              } Tickets`
            )}
            className={" py-4 md:py-8 px-3 md:px-6"}
            bodyClass="space-y-3"
          >
            <LangSwitch
              langs={["en", "es"]}
              selectedLang={selectedLang}
              setSelectedLang={setSelectedLang}
            />
            <div className="font-normal text-text-secondary">
              {t(
                "Choose a ticket type or build a section with multiple ticket types"
              )}
              .
            </div>

            <div className="flex flex-wrap gap-3" role="radiogroup">
              {timeOptions.map((option, idx) => (
                <label
                  key={idx}
                  role="radio"
                  aria-checked={selectedTime === option.value}
                  className={`group relative flex items-center justify-center px-3 md:px-6 py-2 md:py-3 rounded-full border text-base cursor-pointer transition-all duration-300 
                    ${
                      selectedTime === option.value
                        ? "bg-primary text-white shadow border-none"
                        : "bg-white border-slate-300 text-gray-700 hover:bg-gray-50"
                    }`}
                >
                  <input
                    type="radio"
                    name="time"
                    value={option.value}
                    className="hidden"
                    checked={selectedTime === option.value}
                    onChange={() => setSelectedTime(option.value)}
                  />
                  <div className="text-center capitalize">{option.label}</div>
                </label>
              ))}
            </div>

            <div className="bg-white">
              {isLoading || isFetching ? (
                <div className="text-sm text-gray-500">
                  {t("Loading ticket details")}...
                </div>
              ) : (
                getComponentByType(selectedTime)
              )}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default CreateTickets;
